module.exports = __webpack_public_path__ + "static/img/cont2802.30d820b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2802.jpg
// module id = Tl7J
// module chunks = 0